const Image = ELEMENT.Image;
const loadImage = Image.methods.loadImage

Image.created = function () {
  if (!_.trim(this.src)) {
    this.loading = false;
    this.error = true;
  }
}

Object.assign(Image.methods, {
  loadImage() {
    if (this.$isServer) return;
    if (!_.trim(this.src)) {
      this.loading = false;
      this.error = true;
      this.handleError({
        message: 'src属性为空，图片加载失败'
      });
      return;
    }
    loadImage.call(this);
  }
});